<template>
  <div>
    <v-card
      v-if="selectLists"
      class="mb-2 light-green lighten-4"
      @click="editScheduledTaskClick"
    >
      <v-card-text>
        <div class="d-flex">
          <div style="width: 32px;" class="mt-1">
            <v-icon :color="taskPriorityColor(st.Priority)">
              {{ taskPriorityIcon(st.Priority) }}
            </v-icon>
          </div>
          <div>
            <div>{{ taskTypeDescription }}</div>
            <div>{{ st.CustomerName }}</div>
          </div>
          <v-spacer />
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  absolute
                  right
                  top
                  v-bind="attrs"
                  v-on="on"
                  @click="editScheduledTaskClick"
                >
                  <v-icon :color="feature.tasks.color">
                    {{ feature.tasks.icon }}
                  </v-icon>
                </v-btn>
              </template>
              <span>Edit Task</span>
            </v-tooltip>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { feature } from '@/use/Constants'
import { selectListCache } from '@/services/SelectListCache'
export default {
  name: 'TaskListItemCard',
  props: {
    st: {
      type: Object,
      required: true
    }
  },
  setup(props, context) {
    const selectLists = ref()

    const initForm = async () => {
      await loadSelectLists()
    }

    const loadSelectLists = async () => {
      const selectListNames = [selectListCache.name.TaskTypes]
      selectLists.value = await selectListCache.get(selectListNames)
    }

    const taskTypeDescription = computed(() => {
      const text = selectListCache.attribute(
        selectListCache.name.TaskTypes,
        props.st.TaskDefId,
        'Text'
      )
      return text
    })

    const editScheduledTaskClick = () => {
      context.emit('edit', props.st.ScheduledTaskId)
    }

    const taskPriorityColor = value => {
      return selectListCache.attribute(
        selectListCache.name.TaskPriorities,
        value,
        'Color'
      )
    }

    const taskPriorityIcon = value => {
      return selectListCache.attribute(
        selectListCache.name.TaskPriorities,
        value,
        'Icon'
      )
    }

    initForm()
    return {
      feature,
      selectLists,
      taskTypeDescription,
      taskPriorityColor,
      taskPriorityIcon,
      editScheduledTaskClick
    }
  }
}
</script>

<style lang="scss" scoped></style>
